module.exports = __webpack_public_path__ + "img/bemer_behandlung.8215334c.jpg";